import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { OrdersAndTransactionsTabs } from '.';
import { CustomerInfoContext } from '../../../../contexts/CustomerInfoContext';
import { resources } from '../../../../resources/resources';
import { PlatformBenefitTypes } from '../../../../enums';

interface OrdersAndTransactionsTabNavProps {
  activeTab: OrdersAndTransactionsTabs;
  onTabChange: (tab: OrdersAndTransactionsTabs) => void;
}

export const OrdersAndTransactionsTabNav = (
  props: OrdersAndTransactionsTabNavProps,
) => {
  const { activeTab, onTabChange } = props;
  const { t: translate } = useTranslation();
  const { customerInfo } = useContext(CustomerInfoContext);

  return (
    <ul className="acc-tabs">
      <li
        className={
          activeTab === OrdersAndTransactionsTabs.Orders
            ? 'acc-tab-active'
            : undefined
        }
        onClick={() => onTabChange(OrdersAndTransactionsTabs.Orders)}
      >
        {translate(resources.orders.ordersHistory)}
      </li>
      {customerInfo.platformType === PlatformBenefitTypes.FlexibleBenefits && (
        <li
          className={
            activeTab === OrdersAndTransactionsTabs.Transactions
              ? 'acc-tab-active'
              : undefined
          }
          onClick={() => onTabChange(OrdersAndTransactionsTabs.Transactions)}
        >
          {translate(resources.orders.transactions)}
        </li>
      )}
    </ul>
  );
};
